<template>
  <v-container>
    <h2 class="mb-20 mt-3">Produkty v&nbsp;košíku</h2>
    <div v-if="!loading">
      <div class="basket-item" v-for="n in polozky">
        <div class="basket-item__div">
          <img :src="n.produkt.obrazky.length > 0 ? $imagesBaseUrl + n.produkt.obrazky[0].s3_nazev : null" :alt="'Obrázek ' + n.produkt.nazev">
          <p class="item-title"><eshop-link class="link-black" :to="{ path: '/produkty/' + n.produkt.id }" target="_blank">{{n.produkt.nazev}}</eshop-link></p>
        </div>
        <div class="basket-item__div basket-item__delete">
          <p class="text-primary">{{n.prodejni_cena_celkem | formatMoney}} {{mena.zkratka}}</p>
          <!-- <p class="text-gray item-ks">{{n.mnozstvi}} ks</p> -->
          <v-text-field
            class="item-ks ml-4"
            hide-controls
            hide-details
            type="number"
            solo
            suffix="Ks"
            v-model="n.mnozstvi"
            @input="updateMnozstvi(n)"
          ></v-text-field>
          <v-btn color="red" icon dark @click="deleteClick(n)"><v-icon>delete</v-icon></v-btn>
        </div>
      </div>

      <h2 class="mb-20 mt-50">Způsob doručení</h2>
      <v-radio-group
        v-model="radios"
        class="radio-group default-radio-group"
        hide-details>
        <v-layout row wrap>
          <v-flex>
            <v-radio color="orange" value="posta" class="mb-3">
              <template v-slot:label>
                <div class="radio-group__item">
                  <div>
                    <p class="ma-0 mb-1 item-title"><strong>Česká pošta</strong></p>
                    <p class="ma-0 item-desc text-gray">
                      O&nbsp;průběhu doručení Vás budeme informovat.
                    </p>
                  </div>
                  <p class="mb-0 bold text-gray fs-12"><span v-if="aktivni_postovne!=null">{{aktivni_postovne.cena | formatMoneyInt}}</span><span v-else>--</span> Kč</p>
                </div>
              </template>
            </v-radio>
          </v-flex>
          <v-flex v-if="!me.makler && !me.podrizeny_maklere && !me.zakaznik_maklere">
            <v-radio color="orange" value="predani_poradcem" class="mb-3">
              <template v-slot:label>
                <div class="radio-group__item">
                  <div>
                    <p class="ma-0 mb-1 item-title"><strong>Předání poradcem</strong></p>
                    <p class="ma-0 item-desc text-gray">
                      O&nbsp;průběhu doručení budete informován/a poradcem.
                    </p>
                  </div>
                  <p class="mb-0 bold text-gray fs-12">0 Kč</p>
                </div>
              </template>
            </v-radio>
          </v-flex>
          
        </v-layout>
        <v-radio color="orange" value="osobni_prevzeti">
          <template v-slot:label>
            <div class="radio-group__item radio-group__personal">
              <div class="max-230">
                <p class="ma-0 mb-1 item-title"><strong>Osobní odběr na pobočce</strong></p>
                <p class="ma-0 item-desc text-gray">
                  O&nbsp;průběhu doručení budete informován/a poradcem.
                </p>
              </div>
              <pobocky class="button-office" label="Vyberte pobočku" :hideDetails="true" v-model="doruceni_pobocka_id"></pobocky>
              <p class="mb-0 bold text-gray fs-12">Zdarma</p>
            </div>
          </template>
        </v-radio>
        <v-flex v-if="!me.makler && !me.podrizeny_maklere && !me.zakaznik_maklere">
            <v-radio color="orange" value="uschova" class="mb-3">
              <template v-slot:label>
                <div class="radio-group__item">
                  <div>
                    <p class="ma-0 mb-1 item-title"><strong>Úschova</strong></p>
                    <p class="ma-0 item-desc text-gray">
                      Zboží bude automaticky uloženo v našich trezorech.
                    </p>
                  </div>
                  <p class="mb-0 bold text-gray fs-12">Ceník úschovy naleznete na našich webových stránkách zde.</p>
                </div>
              </template>
            </v-radio>
          </v-flex>
      </v-radio-group>

      <h2 class="mb-20 mt-50">Způsob platby</h2>
      <v-radio-group
        v-model="radios2"
        class="radio-group"
        hide-details>
        <v-layout row wrap>
          <v-flex>
            <v-radio color="orange" value="banka" class="mb-3">
              <template v-slot:label>
                <div class="radio-group__item">
                  <div>
                    <p class="ma-0 mb-1 item-title"><strong>Bankovním převodem</strong></p>
                    <p class="ma-0 item-desc text-gray">
                      Pokyny k platbě Vám budou zaslány na e-mail.
                    </p>
                  </div>
                </div>
              </template>
            </v-radio>
          </v-flex>
          <v-flex>
            <v-radio color="orange" value="penezenka" class="mb-3" :disabled="!povolit_ep">
              <template v-slot:label>
                <div class="radio-group__item">
                  <div>
                    <p class="ma-0 mb-1 item-title"><strong>Elektronická peněženka</strong></p>
                    <p class="ma-0 item-desc text-gray" v-if="!povolit_ep">
                      Na elektronické peněžence není dostatek prostředků.
                    </p>
                  </div>
                </div>
              </template>
            </v-radio>
          </v-flex>
        </v-layout>
      </v-radio-group>

      <div class="summary">
        <v-layout row wrap align-center>
          <v-flex xs12 sm6 md7>
            <h3 class="h2 mb-1">Cena celkem:</h3>
            <p class="bold text-red ma-0">
              Vzhledem k&nbsp;pohybu cen drahých kovů je uvedená cena pouze orientační. <br>
              Konečná cena je určena v&nbsp;den doručení Vaší platby na nás účet
              na základě aktuální ceny drahých kovů.
            </p>
          </v-flex>
          <v-flex xs12 sm6 md5>
            <div class="summary__price">
              <p class="ma-0 bold h2">{{celkem_plus_postovne | formatMoney}} {{mena.zkratka}}</p>
              <v-btn class="button button-buy elevation-0" dark :loading="sending" v-if="celkem_plus_postovne > 0 && !testovaci_klient" @click="objednatClick">Objednat</v-btn>
            </div>
          </v-flex>
        </v-layout>
      </div>

      <!-- <div class="account__person mt-50">
        <v-layout row wrap align-center>
          <v-flex xs12 md5>
            <v-layout row wrap align-center>
              <v-flex>
                <h3 class="h2 text-primary mb-2">{{poradce.nazev_osoby}}</h3>
                <p class="bold mb-1">Telefon: <a class="link-black" :href="'tel:'+poradce.telefon">{{poradce.telefon}}</a></p>
                <p class="bold mb-1">Email: <a class="link-black" :href="'mailto:'+poradce.email">{{poradce.email}}</a></p>
                <p class="text-gray bold mb-0 fs-14">Pro změnu údajů kontaktujte svého poradce.</p>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div> -->
    </div>
  </v-container>
</template>
<script>
  import Base from '../Base'
  export default {
    extends: Base,
    data () {
      return {
        radios: 'predani_poradcem',
        radios2: 'banka',
        items: [
          'Plzeň',
          'Praha'
        ],
        loading: true,
        celkem: 0,
        mena: null,
        polozky: [],
        poradce: null,
        povolit_ep: false,
        sending: false,
        aktivni_postovne: null,
        celkem_plus_postovne: null,
        doruceni_pobocka_id: null
      }
    },
    computed: {
      testovaci_klient (v) {
        return window.testovaci_klient;
      },
      me () {
        return window.$me;
      }
    },
    watch: {
      radios (v) {
        if (v == "posta") {
          if (this.aktivni_postovne != null)
            this.celkem_plus_postovne = this.celkem + this.aktivni_postovne.cena;
        }
        else {
          this.celkem_plus_postovne = this.celkem;
        }
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      load () {
        window.API.get("kosik/detail").then(function(body) {
          this.celkem = body.celkem;
          this.celkem_plus_postovne = body.celkem_plus_postovne;
          this.mena = body.mena;
          this.polozky = body.polozky;
          this.poradce = body.poradce;
          this.postovne = body.postovne;
          this.povolit_ep = body.povolit_ep;
          if (!body.povolit_ep)
            this.radios2 = "banka";
          this.loading = false;
          this.prepocitatPostovne();
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      prepocitatPostovne () {
        var cena_celkem = this.celkem;
        this.aktivni_postovne = this.postovne.filterOne((e) => {
          return e.cena_objednavky_od <= cena_celkem && e.cena_objednavky_do >= cena_celkem;
        });
        if (this.radios == "posta") {
          if (this.aktivni_postovne != null)
            this.celkem_plus_postovne = this.celkem + this.aktivni_postovne.cena;
        }
        else {
          this.celkem_plus_postovne = this.celkem;
        }
      },
      deleteClick(v) {
        window.API.delete("kosik/"+v.produkt.id).then(function(body) {
          this.load();
          window.kosik.changed();
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      objednatClick() {
        if (window.testovaci_klient) {
          this.$router.push({path: "/jednorazove-nakupy"});
        }
        else {
          this.sending = true;
          window.API.post("kosik/objednat", {
            zpusob_doruceni: this.radios,
            zpusob_platby: this.radios2,
            doruceni_pobocka_id: this.doruceni_pobocka_id
          }).then(function(body) {
            this.sending = false;
            this.load();
            window.kosik.changed();
            if (body.created) {
              this.$router.push({path: "/jednorazove-nakupy"});
            }
          }.bind(this)).catch(function(err) {
            this.sending = false;
            console.log(err);
          }.bind(this));
        }
      },
      updateMnozstvi (v) {
        window.API.put("kosik/mnozstvi", {
          produkt: v.produkt.id,
          mnozstvi: v.mnozstvi
        }).then(function(body) {
          this.load();
          window.kosik.changed();
          this.prepocitatPostovne();
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      }
    }
  }
</script>
